import { createSvgIcon } from '../../createSvgIcon';

const strokeProps = {
  fill: 'none',
  stroke: 'currentColor',
  strokeWidth: 2
};

const strokePropsJoin = {
  ...strokeProps,
  strokeLinejoin: 'round' as const
};

const strokePropsRound = {
  ...strokeProps,
  strokeLinecap: 'round' as const,
  strokeLinejoin: 'round' as const
};

const strokePropsCap = {
  ...strokeProps,
  strokeLinecap: 'round' as const
};

export const RobotIcon = createSvgIcon(
  <>
    <path
      d="M22.25 18.5V16C22.25 12.4645 22.25 10.6967 21.1517 9.59835C20.0533 8.5 18.2855 8.5 14.75 8.5H12.25C8.71447 8.5 6.9467 8.5 5.84835 9.59835C4.75 10.6967 4.75 12.4645 4.75 16V18.5C4.75 22.0355 4.75 23.8033 5.84835 24.9017C6.9467 26 8.71447 26 12.25 26H14.75C18.2855 26 20.0533 26 21.1517 24.9017C22.25 23.8033 22.25 22.0355 22.25 18.5Z"
      {...strokePropsJoin}
    />
    <path
      d="M22.25 21C24.0178 21 24.9017 21 25.4508 20.4508C26 19.9017 26 19.0178 26 17.25C26 15.4822 26 14.5983 25.4508 14.0492C24.9017 13.5 24.0178 13.5 22.25 13.5"
      {...strokePropsJoin}
    />
    <path
      d="M4.75 21C2.98223 21 2.09835 21 1.54917 20.4508C1 19.9017 1 19.0178 1 17.25C1 15.4822 1 14.5983 1.54917 14.0492C2.09835 13.5 2.98223 13.5 4.75 13.5"
      {...strokePropsJoin}
    />
    <path
      d="M15.375 2.875C15.375 3.91053 14.5355 4.75 13.5 4.75C12.4645 4.75 11.625 3.91053 11.625 2.875C11.625 1.83947 12.4645 1 13.5 1C14.5355 1 15.375 1.83947 15.375 2.875Z"
      {...strokeProps}
    />
    <path d="M13.5 4.75V8.5" {...strokePropsRound} />
    <path d="M9.75 14.75V16" {...strokePropsRound} />
    <path d="M17.25 14.75V16" {...strokePropsRound} />
    <path d="M11 20.375C11 20.375 11.8333 21 13.5 21C15.1667 21 16 20.375 16 20.375" {...strokePropsCap} />
  </>,
  { displayName: 'RobotIcon', viewBox: '0 0 27 27' }
);
